import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex items-center text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-2"
}

import { Permission, ScriptGetAllParams, ScriptModel } from '@/types';
import { CodeIcon } from '@heroicons/vue/solid';
import { onMounted, ref } from 'vue';
import ScriptListItem from './components/ScriptListItem.vue';
import { useFilterStore, useUiStore } from '@/stores';
import { toast, toastServiceError } from '@/services';
import ScriptService from '@/services/api/ScriptService';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScriptPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();
const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const scripts = ref<ScriptModel[]>([]);

const fetchAllScripts = async () => {
    try {
        setLoading(true);
        const { data } = await ScriptService.getAll<ScriptModel[]>();
        scripts.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const updateScriptStatus = async (script: ScriptModel, isActive: boolean) => {
    try {
        setLoading(true);
        const { data } = await (isActive
            ? ScriptService.activate(script.id)
            : ScriptService.inactivate(script.id));
        toast.success(data.message);
        await fetchAllScripts();
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const handleActivateClick = (script: ScriptModel) => updateScriptStatus(script, true);
const handleInactivateClick = (script: ScriptModel) => updateScriptStatus(script, false);

onMounted(() => {
    if (route.query.clearStateOnSetup) {
        router.replace({ query: {} });
    }

    fetchAllScripts();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(_unref(CodeIcon), {
            class: "mr-1 h-6 w-6 text-gray-500",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('core.entity.Scripts')), 1)
        ])
      ]),
      actions: _withCtx(() => [
        (_ctx.$can(_unref(Permission).CREATE_SCRIPT))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'CreateScript' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UiButton, {
                  variant: "primary",
                  "text-variant": "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Add')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (scripts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scripts.value, (script) => {
              return (_openBlock(), _createBlock(ScriptListItem, {
                key: script.id,
                "model-value": script,
                onActivate: handleActivateClick,
                onInactivate: handleInactivateClick
              }, null, 8, ["model-value"]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_UiPanel, {
            key: 1,
            class: "flex items-center justify-center py-8 text-gray-500"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.messages.noRecordsFound')), 1)
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})